"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNamedOutletHook = exports.createNavigateHook = exports.createRoutes = exports.createResolver = exports.root = void 0;
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const path_to_regexp_1 = require("path-to-regexp");
const sort_route_addresses_1 = __importDefault(require("sort-route-addresses"));
const url_1 = require("utils/url");
// Ensure reuse of component by react-router by caching wrapped component
const cachedWrappedComponent = new WeakMap();
const wrapComponent = (component) => {
    if (cachedWrappedComponent.has(component)) {
        return cachedWrappedComponent.get(component);
    }
    else {
        const wrappedComponent = function WrappedComponent() {
            const params = (0, react_router_1.useParams)();
            return component(params);
        };
        cachedWrappedComponent.set(component, wrappedComponent);
        return wrappedComponent;
    }
};
function _typedRoute(path, componentParam, base, isChildren, parent) {
    const paramComponentMap = componentParam;
    const componentMap = Object.assign(Object.assign({}, base === null || base === void 0 ? void 0 : base.componentMap), paramComponentMap);
    // Don't inherit default component
    if (!(paramComponentMap === null || paramComponentMap === void 0 ? void 0 : paramComponentMap["default"])) {
        delete componentMap["default"];
    }
    const realPath = (((base === null || base === void 0 ? void 0 : base.realPath) || "") + path);
    const matcher = realPath.includes("*")
        ? (path) => true
        : (0, path_to_regexp_1.match)(realPath);
    const route = Object.assign((realPath.includes("*") ? () => "" : (0, path_to_regexp_1.compile)(realPath)), {
        componentMap,
        path,
        type: !(componentMap === null || componentMap === void 0 ? void 0 : componentMap["default"])
            ? "abstract"
            : parent
                ? "parent"
                : undefined,
        realPath,
        children: [],
        dependencies: [],
        match: matcher,
        sub: ((path, Component, { parent, components, } = {
            parent: false,
        }) => {
            return _typedRoute(path, Object.assign(Object.assign({}, components), (Component && { default: Component })), route, false, parent);
        }),
        child: ((path, Component, { parent, components, } = {
            parent: false,
        }) => {
            return _typedRoute(path, Object.assign(Object.assign({}, components), (Component && { default: Component })), route, true, parent);
        }),
    });
    if (isChildren) {
        base === null || base === void 0 ? void 0 : base.children.push(route);
    }
    else {
        base === null || base === void 0 ? void 0 : base.dependencies.push(route);
    }
    return route;
}
function root() {
    return _typedRoute("");
}
exports.root = root;
const collectRoutes = (routes) => {
    return routes.concat(...routes.map((route) => collectRoutes(route.dependencies)));
};
const collectAllRoutes = (routes) => {
    return routes.concat(...routes.map((route) => collectAllRoutes(route.dependencies)), ...routes.map((route) => collectAllRoutes(route.children)));
};
const _untypeRoutes = (routeMap, namedRoute = false) => {
    var _a;
    const map = {};
    for (const route of namedRoute
        ? collectAllRoutes(routeMap)
        : collectRoutes(routeMap)) {
        const { realPath, componentMap, path } = route;
        if (namedRoute && path === "") {
            continue;
        }
        for (const [key, component] of componentMap
            ? Object.entries(componentMap)
            : []) {
            map[key] = map[key] || {};
            if (map[key][realPath] && map[key][realPath] !== route) {
                if (((_a = map[key][realPath].componentMap) === null || _a === void 0 ? void 0 : _a[key]) === component) {
                    continue;
                }
                console.error("duplicate route", namedRoute, {
                    old: map[key][realPath],
                    new: route,
                    key,
                    realPath,
                });
            }
            map[key][realPath] = route;
        }
    }
    const named = {};
    for (const name of Object.keys(map)) {
        named[name] = (0, sort_route_addresses_1.default)(Object.keys(map[name])).map((realPath) => {
            const { realPath: path, componentMap, children } = map[name][realPath];
            const Component = wrapComponent(componentMap === null || componentMap === void 0 ? void 0 : componentMap[name]);
            const named = namedRoute
                ? undefined
                : children && _untypeRoutes(children);
            return Object.assign(Object.assign({ path }, ((named === null || named === void 0 ? void 0 : named["default"]) && { children: named === null || named === void 0 ? void 0 : named["default"] })), { element: react_1.default.createElement(Component, null) });
        });
    }
    return named;
};
const filterRoot = (routeMap) => {
    const routes = new Set(Object.values(routeMap));
    const traverseChildren = (route) => {
        for (const child of route.children) {
            routes.delete(child);
            traverseChildren(child);
        }
        for (const child of route.dependencies) {
            routes.delete(child);
            traverseChildren(child);
        }
    };
    for (const route of Array.from(routes)) {
        traverseChildren(route);
    }
    return Array.from(routes);
};
const untypeRoutes = (routeMap, namedRoute = false) => {
    // For debug
    for (const [key, value] of Object.entries(routeMap)) {
        value.id = key;
    }
    const routes = filterRoot(routeMap);
    return _untypeRoutes(routes, namedRoute);
};
const defaultReainSearchParams = ["langId"];
const createResolver = (routeMap) => {
    function resolveRoute(id, params, options) {
        const route = routeMap[id];
        try {
            const currentParams = (0, url_1.objectFromSearchParams)(new URLSearchParams(location.search));
            const inheritedParams = (() => {
                var _a;
                const retainSearchParams = (_a = options === null || options === void 0 ? void 0 : options.retainSearchParams) !== null && _a !== void 0 ? _a : defaultReainSearchParams;
                if (!retainSearchParams)
                    return;
                if (retainSearchParams === true) {
                    return currentParams;
                }
                else if (Array.isArray(retainSearchParams)) {
                    return Object.fromEntries(retainSearchParams.map((key) => [
                        key,
                        currentParams[key],
                    ]));
                }
            })();
            const mergedParams = Object.assign(Object.assign({}, inheritedParams), options === null || options === void 0 ? void 0 : options.searchParams);
            const searchParamString = mergedParams && Object.keys(mergedParams || {}).length
                ? "?" + (0, url_1.objectToSearchParams)(mergedParams).toString()
                : "";
            return route(params) + searchParamString;
        }
        catch (e) {
            return "";
        }
    }
    return resolveRoute;
};
exports.createResolver = createResolver;
const createRoutes = (routeMap, name = "default") => {
    const untypedRoutes = untypeRoutes(routeMap);
    return untypedRoutes[name];
};
exports.createRoutes = createRoutes;
const createNavigateHook = (routeMap) => {
    const resolver = (0, exports.createResolver)(routeMap);
    return () => {
        const originalNavigate = (0, react_router_1.useNavigate)();
        function navigate(id, params, options) {
            const _a = options || {}, { retainSearchParams } = _a, navigateOptions = __rest(_a, ["retainSearchParams"]);
            const resolverOptions = { retainSearchParams };
            originalNavigate(resolver(id, (params || {}), resolverOptions), navigateOptions);
        }
        return navigate;
    };
};
exports.createNavigateHook = createNavigateHook;
const createNamedOutletHook = (routeMap) => {
    const untypedRoutes = untypeRoutes(routeMap, true);
    // console.log("Named routes created", untypedRoutes, routeMap);
    return (name) => {
        const { matches } = (0, react_1.useContext)(react_router_1.UNSAFE_RouteContext);
        const match = matches[matches.length - 1];
        const { route } = match;
        if (!route) {
            return function DammyOutlet() {
                return react_1.default.createElement(react_1.default.Fragment, null);
            };
        }
        const routes = untypedRoutes[name];
        if (!routes) {
            console.error("route has no named routes", route);
        }
        const filiteredRoutes = (routes || [])
            .map((item) => {
            var _a, _b, _c;
            if ((_a = item.path) === null || _a === void 0 ? void 0 : _a.startsWith(route.path || "")) {
                return Object.assign(Object.assign({}, item), { path: (_b = item.path) === null || _b === void 0 ? void 0 : _b.slice((_c = route.path) === null || _c === void 0 ? void 0 : _c.length) });
            }
            else {
                return null;
            }
        })
            .filter((item) => item);
        return () => (0, react_router_1.useRoutes)(filiteredRoutes);
    };
};
exports.createNamedOutletHook = createNamedOutletHook;
